declare global {
	interface Window {
		CookieScript?: {
			instance?: {
				currentState: () => { categories?: string[] };
			};
		};
	}
}

// Utility function to check if all required CookieScript categories have been accepted
export const hasConsent = (requiredCategories: string[], skipCheck: boolean): boolean => {
	if (!window.CookieScript || !window.CookieScript.instance) {
		console.warn("CookieScript instance is not available");

		if (import.meta.env.DEV) {
			return true;
		}
	}

	if (skipCheck) {
		return true;
	}

	const consentMap: Record<string, string> = {
		necessary: "strict",
		performance: "performance",
		targeting: "targeting",
		functionality: "functionality",
		unclassified: "unclassified",
	};

	const cookieScript = window.CookieScript?.instance;
	if (!requiredCategories || !Array.isArray(requiredCategories) || requiredCategories.length === 0) {
		console.warn("No required categories provided");
		return false;
	}
	if (!cookieScript) {
		console.warn("CookieScript instance not found");
		return false;
	}

	const acceptedCategories = cookieScript.currentState().categories || [];
	if (!acceptedCategories || !Array.isArray(acceptedCategories)) {
		console.warn("No accepted categories found");
		return false;
	}

	const consent = requiredCategories.every((category) => acceptedCategories.includes(consentMap[category]));

	return consent;
};

// Utility to open the CookieScript settings modal via DOM interaction
export const openConsentSettings = (): void => {
	const cookieScript = window.CookieScript?.instance;

	cookieScript?.show();
};

export const addCookieEventListeners = (): void => {
	const cookieScriptEvents = [
		"CookieScriptLoaded",
		"CookieScriptAccept",
		"CookieScriptAcceptAll",
		"CookieScriptReject",
	];
	const updateEvent = new Event("ConsentUpdated");

	cookieScriptEvents.forEach((event) => {
		window.addEventListener(event, function () {
			window.dispatchEvent(updateEvent);
		});
	});
};
